import { getAppSettingsValue } from '../../common/selectors/app-settings-base-selectors';

export const getTextAlignment = (state, layoutParams) =>
  getAppSettingsValue({
    state,
    key: layoutParams.textAlignment.appSettingsPath,
    fallback: layoutParams.textAlignment.defaultAlignment,
  });
